import caretLeftIcon from "../assets/icons/caret-left.png";

export default function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <button className={"h-8 w-8 rounded-full"} onClick={onClick}>
      <img src={caretLeftIcon} alt="" className="h-15 w-15 -ml-2" />
    </button>
  );
}
